import React from "react";
import { useLocation } from "react-router-dom";

const SectionTitle = ({ label, title, align = "center" }) => {
  const location = useLocation();

  const noMarginRoutes = ["/about", "/contact", "/  "];

  const shouldRemoveMargin = noMarginRoutes.includes(location.pathname);

  return (
    <header
      className={`el-heading ${align === "center" ? "el-heading-center" : ""}`}
      style={shouldRemoveMargin ? {} : { marginBottom: "3rem" }}
    >
      <div className="el-icon">
        <h3 className="section-subtitle 2xl:text-2xl">
          <span>{label}</span>
        </h3>
      </div>

      <h4 className="section-main-title">
        <span>{title}</span>
      </h4>

      <div className="divider-group">
        <div className="divider divider-1-reverse divider-1-1"></div>
        <div className="divider divider-1-reverse divider-1-2"></div>
      </div>
    </header>
  );
};

export default SectionTitle;
